module.exports = __webpack_public_path__ + "img/logo.5f860ac3.png";